<template>
  <div :class="$vuetify.breakpoint.smAndUp ? 'd-flex' : ''">
    <div class="d-flex">
      <!-- <img height="56px" width="56px" :src="GroupImage" id="videoSymbol" /> -->
      <img height="56px" width="56px" :src="GroupImage" id="videoSymbol" />
      <div class="text__class py-3">Share your trades with your community</div>
    </div>
    <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
    <div class="py-2">
      <!-- <group-create-btn> </group-create-btn> -->
      <v-btn
        color="#2D8CFF"
        class="btn__class text-none"
        height="44"
        :width="$vuetify.breakpoint.xsOnly ? '100%' : ''"
        @click="createGroup"
      >
        <span> Create New Group </span>
      </v-btn>
    </div>
  </div>
</template>
<script>
// import GroupCreateBtn from "../GroupCreateBtn.vue";
import { mapActions } from "vuex";

export default {
  name: "MyProfileNoGroups",
  //   components: { GroupCreateBtn },
  data() {
    return {
      GroupImage: require("@/assets/images/network.svg"),
    };
  },

  methods: {
    ...mapActions({
      toggleGroupModal: "group/toggleShowGroupModal",
    }),
    createGroup() {
      this.$logEvent("add_new_group_button");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_new_group_button");
      }
      console.log("clicked on add group");
      this.toggleGroupModal({
        show: true,
        type: "add",
        profile_object: this.profile_object,
      });
    },
  },
};
</script>
<style scoped>
.btn__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  color: #ffffff;
}
#videoUploadMainDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 39px;
}

#subDiv {
  display: flex;
  align-items: center;
}

#videoSymbol {
  margin-right: 20px;
  color: #b5b5b5;
}

#uploadVideoBtn {
  float: right;
}

@media all and (max-width: 600px) {
  #uploadVideoBtn {
    float: left;
    width: 304px;
    height: 44px;
    background-color: #2d8cff;
    border-radius: 10px;
    /* Padding: 12px, 28px, 12px, 28px; */
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  #videoSymbol {
    height: 49px;
    width: 79px;
    left: 28px;
    top: 1126px;
    opacity: 60%;
  }

  .text__class {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 900;
    color: black;
    font-size: large;
    font-size: 17px;
    line-height: 23.22px;
  }

  /* #UploadVideosComponent {
          width: 336px;
          height: 149px;
          border-radius: 10px;
          background-color: #FFFFFF;
      } */
}

@media all and (min-width: 1000px) {
  #uploadVideoBtn {
    /* float: left; */
    width: 211px;
    height: 52px;
    background-color: #2d8cff;
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 10px;
    /* Padding: 0px, 3px, 0px, 0px; */
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  .text__class {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 900;
    color: black;
    font-size: large;
    font-size: 20px;
    line-height: 27.32px;
  }
}

.mobileClass {
  padding-top: 5px;
  padding-bottom: 2px;
}

.desktopClass {
  padding-top: 1px;
  padding-right: 18px;
  padding-left: 17px;
}

/* #UploadVideosComponent{
      padding-bottom: 30px;
  } */
</style>
